var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephoneStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv",
    focusable: "false",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.036 20.524 20.55 1.998l1.471 1.47L3.508 21.995z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.682,24.006a5.159,5.159,0,0,1-1.632-.266,25.11,25.11,0,0,1-9.757-6.033A25.094,25.094,0,0,1,.261,7.951,5.107,5.107,0,0,1,1.789,2.434L3.689.806a3.352,3.352,0,0,1,4.8.452L10.9,4.275a3.009,3.009,0,0,1,.211,3.449l-1.1,1.785a1,1,0,0,0,.143,1.232l3.1,3.1a1,1,0,0,0,1.231.144l1.786-1.1a3.005,3.005,0,0,1,3.449.211l3.017,2.414a3.353,3.353,0,0,1,.452,4.8l-1.628,1.9A5.105,5.105,0,0,1,17.682,24.006ZM5.869,2a1.346,1.346,0,0,0-.878.325L3.09,3.953a3.116,3.116,0,0,0-.933,3.365,23.1,23.1,0,0,0,5.55,8.975,23.1,23.1,0,0,0,8.976,5.549,3.116,3.116,0,0,0,3.365-.932l1.627-1.9a1.351,1.351,0,0,0-.183-1.935l-3.017-2.414a1,1,0,0,0-1.15-.07l-1.785,1.1a2.987,2.987,0,0,1-3.695-.432l-3.1-3.1a2.99,2.99,0,0,1-.432-3.7l1.1-1.785a1,1,0,0,0-.07-1.15L6.925,2.508A1.345,1.345,0,0,0,5.869,2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneStroke);
export default __webpack_public_path__ + "static/media/telephone-stroke.d73673e06cc4291d762ed3a092eaed4b.svg";
export { ForwardRef as ReactComponent };